import React, { useMemo, useEffect } from 'react';
import { Button } from 'antd';
import Checkbox from '@lingxi-common-component/sirius-ui/Checkbox';
import style from './index.module.scss';
import WarnIcon from '@web-common/components/UI/Icons/svgs/WarnSvg';
import { apiHolder as api, getIn18Text } from 'api';
import { useAppSelector, useAppDispatch } from '@web-common/state/createStore';
import { actions as mailTabActions } from '@web-common/state/reducer/mailTabReducer';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
const eventApi = api.api.getEventApi();
const ErrorModal = (props) => {
    const { cond } = props;
    const errModalData = useAppSelector(state => state.mailReducer.errModalData);
    const currentTabId = useAppSelector(state => state.mailTabReducer.currentTab.id);
    const mails = useAppSelector(state => state.mailReducer.mails);
    const currentMail = useAppSelector(state => state.mailReducer.currentMail);
    const tabList = useAppSelector(state => state.mailTabReducer.tabList);
    const dispatch = useAppDispatch();
    const isCurMail = useMemo(() => {
        if (!(errModalData === null || errModalData === void 0 ? void 0 : errModalData.errModalMailId))
            return true;
        if ('innerWeb' === cond) {
            return (errModalData === null || errModalData === void 0 ? void 0 : errModalData.errModalMailId) === (currentMail === null || currentMail === void 0 ? void 0 : currentMail.cid);
        }
        if ('mailBox' === cond) {
            return (errModalData === null || errModalData === void 0 ? void 0 : errModalData.errModalMailId) === currentTabId;
        }
        return true;
    }, [cond, currentMail, errModalData, currentTabId]);
    const toCheckMail = (checkMailId) => {
        if (!checkMailId)
            return;
        dispatch(mailActions.doSetTooltipVisible(false));
        if ('mailBox' === cond) {
            if (mails.find(mail => mail.cid === checkMailId) && tabList.find(tab => tab.id === checkMailId)) {
                dispatch(mailTabActions.doChangeCurrentTab(checkMailId));
                dispatch(mailActions.doChangeCurrentMail(checkMailId));
            }
        }
        if ('innerWeb' === cond) {
            if (mails.find(mail => mail.cid === checkMailId)) {
                dispatch(mailActions.doChangeCurrentMail(checkMailId));
            }
        }
    };
    useEffect(() => {
        const keydown = (e) => {
            if (e.key === 'Enter') {
                continueSend();
            }
            if (e.key === 'Escape') {
                cancelFn();
            }
        };
        document.addEventListener('keydown', keydown);
        return () => {
            document.removeEventListener('keydown', keydown);
        };
    }, []);
    const cancelFn = () => {
        dispatch(mailActions.doRemErrModalDataFun(undefined));
        dispatch(mailActions.doSetTooltipVisible(false));
    };
    const continueSend = () => {
        if (errModalData === null || errModalData === void 0 ? void 0 : errModalData.continueCallback) {
            errModalData === null || errModalData === void 0 ? void 0 : errModalData.continueCallback();
            dispatch(mailActions.doRemErrModalDataFun(undefined));
        }
        eventApi.sendSysEvent({
            eventName: 'toSendMail',
            eventStrData: '',
            eventData: { sendMailId: errModalData === null || errModalData === void 0 ? void 0 : errModalData.errModalMailId, cond: 'continueSend', checkbox: true },
        });
    };
    const checkBoxMemo = useMemo(() => {
        return (!!(errModalData === null || errModalData === void 0 ? void 0 : errModalData.showCheckbox) && (React.createElement("div", { className: style.checkbox },
            React.createElement(Checkbox, { checked: errModalData === null || errModalData === void 0 ? void 0 : errModalData.checkboxChecked, onChange: e => {
                    e.stopPropagation();
                    dispatch(mailActions.doCoverErrModalData({ checkboxChecked: !(errModalData === null || errModalData === void 0 ? void 0 : errModalData.checkboxChecked) }));
                } }, (errModalData === null || errModalData === void 0 ? void 0 : errModalData.checkboxText) || getIn18Text('XIACIBUZAITIX')))));
    }, [errModalData === null || errModalData === void 0 ? void 0 : errModalData.showCheckbox, errModalData === null || errModalData === void 0 ? void 0 : errModalData.checkboxChecked]);
    return (React.createElement("div", { className: `${style.modalBg}`, onClick: () => {
            dispatch(mailActions.doSetTooltipVisible(false));
        } },
        React.createElement("div", { className: `${style.modalContent}`, onClick: e => {
                e.stopPropagation();
            } },
            React.createElement("div", { className: `${style.modalIcon}` },
                React.createElement(WarnIcon, null)),
            React.createElement("div", { className: `${style.modalText}` },
                React.createElement("div", { className: `${style.title}` }, (errModalData === null || errModalData === void 0 ? void 0 : errModalData.errorText) || ''),
                React.createElement("div", { className: `${style.errorDoc}` }, (errModalData === null || errModalData === void 0 ? void 0 : errModalData.errorDoc) || ''),
                React.createElement("div", { className: `${style.btns}` },
                    React.createElement("div", null),
                    !isCurMail ? (React.createElement("div", null,
                        React.createElement(Button, { className: `${style.cancel}`, size: "small", onClick: () => {
                                dispatch(mailActions.doSetTooltipVisible(false));
                            } }, getIn18Text('ZHIDAOLE')),
                        React.createElement(Button, { className: `${style.save}`, size: "small", onClick: () => toCheckMail && toCheckMail(errModalData === null || errModalData === void 0 ? void 0 : errModalData.errModalMailId) }, getIn18Text('QUCHAKAN')))) : (React.createElement(React.Fragment, null, (errModalData === null || errModalData === void 0 ? void 0 : errModalData.isSimpleTooltip) ? (React.createElement("div", null,
                        React.createElement(Button, { className: `${style.save}`, size: "small", onClick: () => {
                                dispatch(mailActions.doSetTooltipVisible(false));
                            } }, getIn18Text('ZHIDAOLE')))) : (React.createElement(React.Fragment, null,
                        checkBoxMemo,
                        React.createElement("div", null,
                            React.createElement(Button, { className: `${style.cancel}`, size: "small", onClick: () => {
                                    cancelFn();
                                } },
                                getIn18Text('QUXIAO'),
                                ' Esc'),
                            React.createElement(Button, { className: `${style.save}`, size: "small", onClick: e => {
                                    e.stopPropagation();
                                    continueSend();
                                } },
                                getIn18Text('JIXUFASONG'),
                                ' ↩')))))))),
            React.createElement("div", { className: "" }))));
};
export default ErrorModal;
